import { DataTableService } from './../../../../../shared/data-table/data-table.service';
import { Component, OnInit } from '@angular/core';
import { ColumnDef, PageOptions } from 'src/app/shared/data-table/data-table.interface';
import { UserMaintenanceService } from 'src/modules/api';
import { Requestor } from 'src/modules/api/user-maintenance.service';
import { finalize, filter } from 'rxjs/operators';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { AddUserModalComponent } from '../add-user/add-user-modal.component';
import { LazyLoadEvent } from 'primeng/api';

const RequestType = {
   GRANT: 'grant',
   DENY: 'deny'
};

@Component({
   selector: 'user-manage-request-access',
   templateUrl: './user-manage-request-access.component.html',
   styleUrls: ['./user-manage-request-access.component.scss']
})
export class UserManageRequestAccessComponent implements OnInit {

   pageOptions: PageOptions = this.dataTableService.pageOptionsDefaultSort('rFirstName');

   selectedRequestor: Requestor;
   requestors: Requestor[];
   total = 0;
   loading = false;

   columns: ColumnDef[] = [
      { field: 'rLastName', name: 'Last Name', width: '8em', editable: false },
      { field: 'rFirstName', name: 'First Name', width: '8em', editable: false },
      { field: 'rGmin', name: 'GMIN', width: '6em', editable: false },
      { field: 'rEmail', name: 'Email', editable: false },
      { field: 'reason', name: 'Reason', width: '16em', editable: false }
   ];

   constructor(
      private readonly dialog: MatDialog,
      private readonly userMaintenanceService: UserMaintenanceService,
      private readonly dataTableService: DataTableService
   ) { }

   get hasSelectedRequestor(): boolean {
      return !!this.selectedRequestor;
   }

   ngOnInit() { }

   onLazyLoad(event: LazyLoadEvent) {
      this.pageOptions.order = event.sortOrder === 1 ? 'asc' : 'desc';
      this.pageOptions.size = event.rows;
      this.pageOptions.sort = event.sortField;
      this.pageOptions.page = event.first / this.pageOptions.size;

      this.loadRequestors();
   }

   loadRequestors() {
      this.loading = true;
      this.userMaintenanceService.getRequestors(this.pageOptions)
         .pipe(finalize(() => this.loading = false))
         .subscribe({
            next: res => {
               if (res) {
                  this.requestors = res.data;
                  this.total = res.totalCount;
               }
            }
         });
   }

   updateSelectedRequestor(requestor: Requestor) {
      this.selectedRequestor = requestor;
   }

   onDenyAccessClick() {
      this.dialog.open(AddUserModalComponent, {
         disableClose: true,
         data: {
            selectedRequestor: this.selectedRequestor,
            requestType: RequestType.DENY,
            isRequestor: true
         },
      }).afterClosed()
         .pipe(filter(res => res && res.reload))
         .subscribe((res: any) => this.loadRequestors());
   }

   onGrantAccessClick() {
      this.dialog.open(AddUserModalComponent, {
         disableClose: true,
         data: {
            selectedRequestor: this.selectedRequestor,
            requestType: RequestType.GRANT,
            isRequestor: true
         },
      }).afterClosed()
         .pipe(filter(res => res && res.reload))
         .subscribe((res: any) => this.loadRequestors());
   }

}
